"use strict";

var _toConsumableArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var SearchResultItem_v2_1 = __importDefault(require("./SearchResultItem_v2"));

var frontend_expansion_1 = require("@ryerson/frontend.expansion");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var SearchResults_helpers_v2_1 = require("./SearchResults_helpers_v2");

var SearchResultsContext_v2_1 = require("./SearchResultsContext_v2");

var SearchResultsTypes_v2_1 = require("./SearchResultsTypes_v2");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var StyledComponents_1 = require("../Footer/Helpers/StyledComponents");

var FullStructuredHeader_1 = require("../Header/FullStructuredHeader");

var NotificationsContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: fixed;\n\twidth: 100%;\n\ttop: 0;\n\toverflow: hidden;\n\tz-index: 99;\n\tbox-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 0px 17.869px rgba(0, 0, 0, 0.0417275),\n\t\t0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725);\n"])));
var ResultsWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\tz-index: 99;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});
var ResultsAccordionWrapper = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tpadding: 20px;\n\tposition: absolute;\n\tleft: 0px;\n\tright: 0px;\n\t", ";\n"])), function (props) {
  var bgColor = props.bgColor;
  return (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\tbackground: ", ";\n\t\t"])), bgColor);
});

var ProductResultsSection_mobile = function ProductResultsSection_mobile(_ref) {
  var items = _ref.items,
      sliceSize = _ref.sliceSize,
      sectionTitle = _ref.sectionTitle,
      isRecentlyPurchased = _ref.isRecentlyPurchased;
  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    direction: "column",
    css: {
      marginTop: 20
    },
    children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      weight: "bold",
      size: "xs",
      children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        css: {
          gap: 5,
          alignItems: "center"
        },
        children: [isRecentlyPurchased && (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: "history",
          size: "xs"
        }), sectionTitle]
      })
    }), items === null || items === void 0 ? void 0 : items.slice(0, sliceSize).map(function (item, index) {
      return (0, jsx_runtime_1.jsx)(SearchResultItem_v2_1.default, {
        isMobile: true,
        item: item,
        index: index
      }, item.id);
    })]
  });
};

var ResourceSection_Mobile = function ResourceSection_Mobile(_ref2) {
  var articles = _ref2.articles,
      titleLabel = _ref2.titleLabel,
      linkLabel = _ref2.linkLabel,
      _showMoreProducts = _ref2.showMoreProducts,
      storeDirectory = _ref2.storeDirectory,
      sliceSize = _ref2.sliceSize,
      urlHashTab = _ref2.urlHashTab;

  var _ref3 = (0, frontend_theme_1.useTheme)(),
      theme = _ref3.theme;

  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      header = _theme$colors$primary.header,
      text = _theme$colors$primary.text,
      darkGray = _theme$colors$primary.darkGray;
  var headings = theme.typography.fontFamilies.headings;

  var _ref4 = (0, react_1.useState)(true),
      _ref5 = _slicedToArray(_ref4, 2),
      displayDivider = _ref5[0],
      setDisplayDivider = _ref5[1];

  var _ref6 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      formatArticleLink = _ref6.formatArticleLink,
      isGatsbyLinkType = _ref6.isGatsbyLinkType;

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(frontend_expansion_1.Accordion, {
      variant: "line",
      multiple: true,
      children: (0, jsx_runtime_1.jsxs)(frontend_expansion_1.AccordionTab, {
        onOpen: function onOpen() {
          setDisplayDivider(false);
        },
        onClose: function onClose() {
          setDisplayDivider(true);
        },
        header: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          direction: "row",
          alignItems: "center",
          css: {
            gap: 10
          },
          children: [(0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.ImageContainer, {
            bgColor: white,

            /*images from static assets, the section’s title can be used to find the asset by removing the spaces in the label*/
            src: "/static-assets/images/search-bar/".concat(titleLabel.replace(" ", ""), ".png")
          }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            css: {
              fontFamily: headings
            },
            color: header,
            size: "xl",
            children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              css: {
                gap: 5,
                alignItems: "center"
              },
              children: titleLabel
            })
          })]
        }),
        circled: true,
        maxHeight: "1000px",
        defaultOpen: !displayDivider,
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
          css: {
            marginTop: 10,
            marginBottom: 10
          },
          direction: "column",
          children: articles === null || articles === void 0 ? void 0 : articles.filter(function (element) {
            return !!element;
          }).slice(0, sliceSize).map(function (article, index) {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
              children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
                gatsby: isGatsbyLinkType(article.category !== "location" && article.category !== "blog"),
                to: formatArticleLink(article.link),
                children: (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                  style: (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\t\t\tpadding: 10px 0px;\n\t\t\t\t\t\t\t\t\t\t\t"]))),
                  children: (0, jsx_runtime_1.jsx)("span", {
                    css: {
                      fontSize: "12px"
                    },
                    children: article.title
                  })
                })
              }, "article-".concat(index))
            });
          })
        }), (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.LinkSection, {
          label: linkLabel,
          showMoreProducts: function showMoreProducts() {
            return _showMoreProducts() + urlHashTab;
          }
        }), (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
          color: text,
          css: {
            width: "100%",
            marginTop: 20,
            marginBottom: 10,
            borderTop: "0.5px"
          }
        })]
      })
    }), displayDivider && (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
      color: darkGray,
      css: {
        width: "100%",
        marginTop: 0,
        marginBottom: 0,
        borderTop: "1px",
        opacity: 1
      }
    })]
  });
};

var SearchResultsMobile_v2 = function SearchResultsMobile_v2() {
  var _a;

  var _ref7 = (0, frontend_theme_1.useTheme)(),
      theme = _ref7.theme;

  var headings = theme.typography.fontFamilies.headings;
  var _theme$colors$primary2 = theme.colors.primary,
      header = _theme$colors$primary2.header,
      text = _theme$colors$primary2.text,
      lighterGray = _theme$colors$primary2.lighterGray;

  var _ref8 = (0, frontend_application_1.useNotifications)(),
      notifications = _ref8.notifications;

  var _ref9 = (0, SearchResultsContext_v2_1.useSearchResults)(),
      _showMoreProducts2 = _ref9.showMoreProducts,
      content = _ref9.content;

  var _ref10 = (0, SearchResults_helpers_v2_1.mapSearchResults)((0, SearchResultsContext_v2_1.useSearchResults)()),
      recentlyPurchased = _ref10.recentlyPurchased,
      matchingProducts = _ref10.matchingProducts,
      hasRecentlyPurchasedItems = _ref10.hasRecentlyPurchasedItems,
      articleResources = _ref10.articleResources,
      mappedMegamenu = _ref10.mappedMegamenu;

  var _ref11 = (0, react_1.useState)(true),
      _ref12 = _slicedToArray(_ref11, 2),
      displayProductSectionDivider = _ref12[0],
      setDisplayProductSectionDivider = _ref12[1]; // if there are more than 3 recently purchased items, only display 3


  var recentlyPurchasedSliceSize = Math.min(recentlyPurchased.length, FullStructuredHeader_1.HEADER_SEARCH_LIMIT); // only display 3 products in the search results, so if there are 3 recently purchased items, don’t display any other products

  var otherProductsSliceSize = FullStructuredHeader_1.HEADER_SEARCH_LIMIT - recentlyPurchasedSliceSize;
  return (0, jsx_runtime_1.jsxs)(ResultsWrapper, {
    bgColor: lighterGray,
    children: [(notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (notification) {
      return notification.type === frontend_application_1.NotificationsType.AddToCart;
    }).length) > 0 && (0, jsx_runtime_1.jsx)(NotificationsContainer, {
      children: (_a = notifications === null || notifications === void 0 ? void 0 : notifications.filter(function (notification) {
        return notification.type === frontend_application_1.NotificationsType.AddToCart;
      }).pop()) === null || _a === void 0 ? void 0 : _a.message
    }), (0, jsx_runtime_1.jsxs)(ResultsAccordionWrapper, {
      direction: "column",
      className: "accordion-search",
      bgColor: lighterGray,
      children: [(0, jsx_runtime_1.jsx)(frontend_expansion_1.Accordion, {
        variant: "line",
        multiple: true,
        children: (0, jsx_runtime_1.jsxs)(frontend_expansion_1.AccordionTab, {
          onOpen: function onOpen() {
            return setDisplayProductSectionDivider(false);
          },
          onClose: function onClose() {
            return setDisplayProductSectionDivider(true);
          },
          header: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
            css: {
              fontFamily: headings
            },
            color: header,
            size: "xl",
            children: content.products
          }),
          size: "md",
          circled: true,
          maxHeight: "1000px",
          defaultOpen: true,
          children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            direction: "column",
            children: [hasRecentlyPurchasedItems && (0, jsx_runtime_1.jsx)(ProductResultsSection_mobile, {
              items: recentlyPurchased,
              sectionTitle:
              /**
               * If we display 3 recently purchased items,
               * Don’t display any section title
               */
              recentlyPurchasedSliceSize >= FullStructuredHeader_1.HEADER_SEARCH_LIMIT ? "" : "".concat(content.recentlyPurchased, ":"),
              sliceSize: recentlyPurchasedSliceSize,
              isRecentlyPurchased: true
            }), !!matchingProducts.length && (0, jsx_runtime_1.jsx)(ProductResultsSection_mobile, {
              items: matchingProducts,
              sectionTitle:
              /**
               * If there are no recently purchased items,
               * Don’t display any section title
               */
              otherProductsSliceSize >= FullStructuredHeader_1.HEADER_SEARCH_LIMIT ? "" : "".concat(content.otherProducts, ":"),
              sliceSize: otherProductsSliceSize
            })]
          }), matchingProducts.length > 2 && (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
            css: {
              marginTop: 10,
              width: "100%"
            },
            children: (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.LinkSection, {
              label: content.moreInProducts,
              showMoreProducts: function showMoreProducts() {
                return _showMoreProducts2() + SearchResultsTypes_v2_1.UrlHashTabs.Products;
              }
            })
          })]
        })
      }), displayProductSectionDivider && (0, jsx_runtime_1.jsx)(StyledComponents_1.Divider, {
        color: text,
        css: {
          width: "100%",
          marginTop: 0,
          marginBottom: 0,
          borderTop: "1px",
          opacity: 1
        }
      }), !hasRecentlyPurchasedItems && matchingProducts.length === 0 && (0, jsx_runtime_1.jsx)(SearchResults_helpers_v2_1.NoResultsFound, {
        label: content.noResults
      }), [mappedMegamenu].concat(_toConsumableArray(articleResources)).filter(function (articleResource) {
        return articleResource.articles.length;
      }).map(function (resource, index) {
        return (0, jsx_runtime_1.jsx)(ResourceSection_Mobile, {
          articles: resource.articles,
          titleLabel: resource.titleLabel,
          showMoreProducts: resource.showMoreProducts,
          linkLabel: resource.linkLabel,
          storeDirectory: resource.storeDirectory,
          sliceSize: 2,
          urlHashTab: resource.urlHashTab
        }, index);
      })]
    })]
  });
};

exports.default = SearchResultsMobile_v2;